
import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import { BigNumber } from '../../../sushi'
import { BIGNUMBER_FMT } from '../../../constants/bakery'

const ArtworkLevel = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  width: auto;
  font-size: 14px;
  justify-content: space-between;
  flex-shrink: 1;
  flex-grow: 1;
  min-width: 95px;
`

export default function InfoSolt ({artwork}: {artwork: any}) {
  const theme = useContext(ThemeContext)
  return (
    <>
      {
        <>
          <ArtworkLevel>
            <Text color={theme.bsText29}>Battle Power: </Text>
            <Text fontSize={16} color={theme.bsText14} fontFamily="Roboto-Bold" marginTop="6px">{new BigNumber(artwork.battlePower).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT)}</Text>
          </ArtworkLevel>
          <ArtworkLevel>
            <Text color={theme.bsText29}>PET to get after abandon: </Text>
            <Text fontSize={16} color={theme.bsText14} fontFamily="Roboto-Bold" marginTop="6px">{new BigNumber(artwork.petToGet).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT)}</Text>
          </ArtworkLevel>
            <ArtworkLevel>
            <Text color={theme.bsText29}>BAKE to get after abandon: </Text>
            <Text fontSize={16} color={theme.bsText14} fontFamily="Roboto-Bold" marginTop="6px">{new BigNumber(artwork.bakeToGet).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT)}</Text>
          </ArtworkLevel>
        </>
      }
    </>
  )
}